import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import React from "react"
import Typography from '@mui/material/Typography'
import styles from "./styles"

const FullScreenModal = ({ open, handleClose, title, children }) => {
  const classes = styles()

  return (
    <Dialog
      className={classes.dialog}
      fullScreen={true}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle className={classes.dialogTitle}>
        <Typography variant="h4" className={classes.title}>{title}</Typography>
        <IconButton
          sx={{
            
          }}
          aria-label="close"
          onClick={handleClose}
          className={classes.dialogCloseButton}
        >
          <CloseIcon fontSize='large'/>
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {children}
      </DialogContent>
    </Dialog>
  )
}

export default FullScreenModal
